module.exports = __webpack_public_path__ + "static/sienna_robinson_drawing-486c2d27f13459f94a4e42327aeda104.jpeg";